import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: '[appTimepicker]'
})
export class TimepickerDirective {

    constructor(
        private model: NgControl
    ) { }

    @HostListener('ngModelChange') ngModelChange() {
        this.modelValue();
    }

    @HostListener('keydown.backspace') onKeyDownBackspace() {
        this.modelValue(true);
    }

    private modelValue(backspace?: boolean) {
        if (this.model) {
            var model: any = this.model;
            if(model.viewModel) {
                if (typeof model.viewModel === 'number') {
                    model.viewModel = model.viewModel.toString();
                }
                this.inputChange(model.viewModel, backspace);
            }
        }
    }

    private inputChange(model: any, backspace?: any) {
        if (model) {
            var newVal = model.replace(/\D/g, '');

            if (backspace) {
                if(newVal.length === 1){
                    newVal = newVal.substring(0, newVal.length - 1);
                }
            }

            if (newVal.length == 0) {
                newVal = '';
            } else if(newVal.length === 1) {
                if (newVal > 2) {
                    newVal = ''
                } else {
                    newVal = newVal.replace(/(\d{1})/, "$1");
                }
            } else if(newVal.length === 2) {
                if (newVal > 23) {
                    newVal = newVal.charAt(0);
                } else {
                    newVal = newVal.replace(/(\d{1})(\d{1})/, "$1$2");
                }
            }  else if(newVal.length === 3) {
                let newVal2 = newVal.charAt(2);
                if (newVal2 > 5) {
                    newVal = newVal.slice(0,2);
                    newVal = newVal.replace(/(\d{1})(\d{1})/, "$1$2");
                } else {
                    newVal = newVal.replace(/(\d{1})(\d{1})(\d{1})/, "$1$2:$3");
                }
            } else if(newVal.length === 4) {
                newVal = newVal.replace(/(\d{1})(\d{1})(\d{1})(\d{1})/, "$1$2:$3$4");
            }

            this.model.valueAccessor.writeValue(newVal);
        }
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/shared/directives/timepicker.directive.ts
 **/